import initialState from './initialState';

export function campaignItemsHasErrored(
  state = initialState.campaignItemsHasErrored,
  action,
) {
  switch (action.type) {
    case 'CAMPAIGN_ITEMS_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function campaignItemsIsLoading(
  state = initialState.campaignItemsIsLoading,
  action,
) {
  switch (action.type) {
    case 'CAMPAIGN_ITEMS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function campaignItems(state = initialState.campaignItems, action) {
  switch (action.type) {
    case 'CAMPAIGN_ITEMS_FETCH_DATA_SUCCESS':
      return action.items;
    default:
      return state;
  }
}

export function campaignItemHasErrored(
  state = initialState.campaignItemHasErrored,
  action,
) {
  switch (action.type) {
    case 'CAMPAIGN_ITEM_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}
export function campaignItemIsLoading(
  state = initialState.campaignItemIsLoading,
  action,
) {
  switch (action.type) {
    case 'CAMPAIGN_ITEMS_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}
export function campaignItem(state = initialState.campaignItem, action) {
  switch (action.type) {
    case 'CAMPAIGN_ITEM_FETCH_DATA_SUCCESS':
      return action.item;
    default:
      return state;
  }
}

export function isNewCampaignSaveSuccess(
  state = initialState.isNewCampaignSaveSuccess,
  action,
) {
  switch (action.type) {
    case 'CAMPAIGN_SAVE_SUCCESS':
      return {
        isSavedSuccess: action.isSavedSuccess,
        campaign: action.campaign,
      };
    default:
      return state;
  }
}

export function isNewCampaignSaveErrored(
  state = initialState.isNewCampaignSaveErrored,
  action,
) {
  switch (action.type) {
    case 'CAMPAIGN_SAVE_ERRORED':
      return {
        isSaveErrored: action.isSaveErrored,
        message: action.message,
      };
    default:
      return state;
  }
}

export function isNewCampaignIsSaving(
  state = initialState.isNewCampaignIsSaving,
  action,
) {
  switch (action.type) {
    case 'CAMPAIGN_IS_SAVING':
      return action.isSaving;
    default:
      return state;
  }
}

export function redirectToCampaignListPage(
  state = initialState.redirectToCampaignListPage,
  action,
) {
  switch (action.type) {
    case 'REDIRECT_TO_CAMPAIGN_LIST':
      return action.doRedirectToCampaignListPage;
    default:
      return state;
  }
}
